import Http from "../http";
import { Profile, Config, KYCProfile } from "../models/account";

export default function(http: Http) {
  return {
    getTokenByFoxONE(code: string): Promise<{ access_token: string }> {
      return http.post("/auth/fox", { data: { code } });
    },

    getFusionTokenByFoxToken(token: string): Promise<{ access_token: string }> {
      return http.post("/login/foxone", { data: { token } });
    },

    getTokenByMixin(code: string): Promise<{ access_token: string }> {
      return http.post("/auth/mixin", { data: { code } });
    },

    getProfile(): Promise<Profile> {
      return http.get("/profile");
    },

    getConfig(): Promise<Config> {
      return http.get("/config");
    },

    getKYCProfile(): Promise<KYCProfile> {
      return http.get("/kyc/profile");
    },

    getKYCLink(url: string): Promise<string> {
      return http.get(`/kyc/faceid?return_url=${url}`);
    },

    bindMixin(code: string) {
      return http.put("/mixin/bind", { data: { code } });
    },

    unBindMixin() {
      return http.delete("/mixin/unbind");
    },

    sendSmsCode(data: { phone_code: string; phone_num: string }) {
      return http.post("/sms/send", { data });
    },

    smsCodeLogin(data: {
      phone_code: string;
      phone_num: string;
      code: string;
    }) {
      return http.post("/sms/login", { data });
    }
  };
}
